import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import type HotelInfo from 'frontend-utils/models/hotelinfo';
import SettingsCompetitorsInputAutocompleteCompetitor from 'lumen/components/settings/competitors/input-autocomplete-competitor';

interface HotelBenchmarkInsightDesiredCompsetInputSearchDesiredCompetitorsSignature {
  Args: {
    isDisabled?: boolean;
    usageTrackingEventTrigger: 'desired-compset' | 'compset-builder';
  };
}

export default class HotelBenchmarkInsightDesiredCompsetInputSearchDesiredCompetitors extends Component<HotelBenchmarkInsightDesiredCompsetInputSearchDesiredCompetitorsSignature> {
  @service('benchmark-insight/competitors/desired-compset')
  declare benchmarkInsightCompetitorsDesiredCompset: Services['benchmark-insight/competitors/desired-compset'];

  @service declare usageAnalytics: Services['usage-analytics'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get excludedHotelinfoIds() {
    return this.benchmarkInsightCompetitorsDesiredCompset.desiredCompetitors.map(
      (competitor) => {
        if (!competitor.id) {
          // When converting from a searched hotelinfo to a desired competitor, we should make sure to set the ID.
          throw new Error('Desired competitor does not have an id');
        }

        return competitor.id;
      },
    );
  }

  @action
  selectHotelinfo(hotelinfo: HotelInfo): void {
    const { desiredCompset } = this.benchmarkInsightCompetitorsDesiredCompset;

    if (!desiredCompset) {
      return;
    }

    desiredCompset.addCompetitor(hotelinfo);

    this.usageAnalytics.track('Wishlist Hotel Added', {
      eventTrigger: this.args.usageTrackingEventTrigger,
    });
  }

  <template>
    <SettingsCompetitorsInputAutocompleteCompetitor
      @excludedHotelinfoIds={{this.excludedHotelinfoIds}}
      @isDisabled={{@isDisabled}}
      @placeholder={{t
        "benchmark_insight.desired_compset.builder.input.placeholder"
      }}
      @selectHotelinfo={{this.selectHotelinfo}}
      @selectedHotelinfo={{null}}
    />
  </template>
}
